import React from "react";
import block from "bem-css-modules";
import highlight from "../../styles/components/Highlight.module.scss";

export default function Highlight({spaceTop, spaceBottom, title, text}) {

  block.setSettings({
    modifierDelimiter: "--",
  });

  const high = block(highlight);

  return (
      <section className={`${high("")}` + ' ' + `${spaceTop && highlight["highlight--spaceTop"]}` + ' ' + `${spaceBottom && highlight["highlight--spaceBottom"]}`}>
        <div className={high("wrapper")}>
            <div className={high("textBlock")}>
                <h2 className={high("head")}>{title || ''}</h2>
                <p className={high("text")}>{text || ''}</p>
            </div>
        </div>
      </section>
  )
}